import React from 'react'
import keywoardsuggest from '../../../../Images/Keyword Suggestions.png'
import adcreation from '../../../../Images/PPC_in_ AD.png'
import campaign from '../../../../Images/PPC_in_ Campaign.png'
import Advertising from '../../../../Images/Search Advertising.png'
import Reporting from '../../../../Images/Performance Reporting.png'
import roi from '../../../../Images/PPC_in_ ROI.png'
import payonclick from '../../../../Images/Pay on Clicks.png'
import moreleads from '../../../../Images/More Leads.png'
import increasesale from '../../../../Images/Increased Sales.png'
import boosttraffic from '../../../../Images/Boost Traffic.png'
import ImmediateResult from '../../../../Images/Immediate Results.png'

function PPCGrowBusiness() {
    return (
        <>
            <div className="container-fluid seo-growbusiness">
                <div className="container-xl">
                    <div className="row growbusiness-text">
                        <h1>How Can We Help You Grow Your Business through PPC? </h1>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box  '>
                                <img src={ImmediateResult} alt="" width={55} />
                                <h2>Immediate Results</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={boosttraffic} alt="" width={55} />
                                <h2>Boost Traffic</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={payonclick} alt="" width={55} />
                                <h2>Pay on Clicks</h2>
                            </div>
                        </div>

                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={moreleads} alt="" width={55} />
                                <h2>More Leads</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={increasesale} alt="" width={55} />
                                <h2>Increased Sales</h2>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid  mb-5">
                <div className="container-xl">
                    <div className="row seo-work">
                        <h1>Our PPC Work Includes</h1>
                        <p>Unlock PPC success through our services: Keyword research, ad optimization, campaign management, landing page enhancement, budget tracking, and comprehensive performance reporting. Experience the power of our PPC expertise.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={keywoardsuggest} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Keyword Research and Selection</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Keyword research is essential for PPC success. It identifies the right keywords for ads to reach a search audience effectively.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={adcreation} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Ad Creation and Optimization</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Compelling ad copy is crucial for customer engagement. Optimization refines ad elements to boost clicks and conversions, aligning with campaign goals.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={campaign} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Campaign Management</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Experienced campaign management involves constant adjustments for competitive and cost-effective PPC success.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Advertising} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Landing Page Optimization</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Optimized landing pages are essential for converting ad clicks into leads or sales. They align with the ad, load fast, and boost conversions.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={roi} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Budget and ROI Tracking</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Efficiently manage PPC budgets, meticulously track ad spend, and adjust for maximum ROI, ensuring you make the most of your advertising budget.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Reporting} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Performance Analytics and Reporting</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Detailed performance analytics and transparent reporting reveal the impact of our efforts on your PPC strategy and business growth.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default PPCGrowBusiness